import { useParams } from "@tanstack/react-router";

// Component imports

import { StaffCardExisting } from "./StaffCardExisting";
import { StaffCardAdd } from "./StaffCardAdd";

// Material-ui imports
import Typography from "@mui/material/Typography";

export function StaffCard({ newStaff }) {
  const { id } = useParams({ strict: false });

  return (
    <>
      <Typography variant="h5" sx={{ pb: 1 }}>
        Staff Card - {id === "add" ? "New" : id}
      </Typography>
      {/* {id === "add" ? <StaffCardAdd /> : <StaffCardExisting id={id} />} */}
      {newStaff ? <StaffCardAdd /> : <StaffCardExisting id={id} />}
    </>
  );
}
